import * as types from '../actions/actionTypes';
import initialState from './initialState';


        
export default function contableregistrogastoReducer(state= initialState.contableregistrogasto, action){
    let newState;
	switch(action.type){
         case types.LOAD_CONTABLEREGISTROGASTO_LIST_SUCCESS:		
            action.contableregistrogasto.filtroActivo=state.filtroActivo;
            action.contableregistrogasto.filtroActual=state.filtroActual;
            action.contableregistrogasto.showActivos=state.showActivos;
			 action.contableregistrogasto.paginaActual=action.contableregistrogasto.pageable.pageNumber;
			 action.contableregistrogasto.registrosPorPagina=action.contableregistrogasto.size;
            
            return action.contableregistrogasto;

        case types.BORRAR_CONTABLEREGISTROGASTO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(contableregistrogasto => contableregistrogasto.id !== action.contableregistrogasto.id)];          
			return newState;    
            
        case types.ACTIVAR_CONTABLEREGISTROGASTO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(contableregistrogasto => contableregistrogasto.id !== action.contableregistrogasto.id)];          
			 return newState;
            
        case types.SET_FILTRO_CONTABLEREGISTROGASTO:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}